import {COLORS} from "@/charts/utils/constants";

interface OverlayProps {
    centerX: number;
    boundsHeight: number;
    width: number;
}

export const Overlay = ({ centerX, boundsHeight, width }: OverlayProps) => {
    const overlayX = centerX - width / 2;
    const overlayY = 0;
    const overlayHeight = boundsHeight;

    return (
        <>
            <rect
                x={overlayX}
                y={0}
                width={width}
                height={boundsHeight}
                fill={COLORS.fill}
                opacity={0.1}
                stroke={COLORS.stroke}
                strokeWidth={2}
            />
            <rect
                x={overlayX}
                y={overlayY}
                width={width}
                height={overlayHeight}
                fill="none"
                stroke={COLORS.stroke}
                strokeWidth={1}
            />
        </>
    );
};
